import React from "react";
import { HiCalendar } from "react-icons/hi2";
import PublicFeedCard from "../components/explore/publicFeedCard";
import ExploreMenu from "../components/explore/exploreMenu";
import BottomNavBar from "../components/layout/BottomNav";

const Explore = () => {
  return (
    <div>
      <div className="mt-10 mb-10">
        <ExploreMenu></ExploreMenu>
      </div>

      <PublicFeedCard />
      <BottomNavBar></BottomNavBar>
    </div>
  );
};

export default Explore;
